import BuilderModel from "./builderModel";
import Form from "../../../formability/form_builder/models/form";

export default class FormBuilderModel extends BuilderModel {
  rootModel: Form;
  form: Form;
  except = ['form', 'createEmbeddedObject'];
}
